import { queryFirst, queryAll, renderFragment, toFormData, remove, hasClass } from '../domUtil';
import { dialogTemplate } from '../templates';
import { getSelectedPid } from './utils/productTileData';
import { SELECTOR_PRODUCT_TILE } from './productTileConstants';
import { addToCartAlert } from '../templates';
import { getAddToCartAnalyticsData } from '../product/helper';
const { ensureFreshCsrfToken } = require('../utils/csrfRefresh');

const $body = $('body');

/**
 * Check is cart page
 *
 * @param {HTMLElement} container - product tile element
 * @returns {boolean} flowIPAddresses
 */
function isCartPage() {
    return !!queryFirst('#my-tote');
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    if (!response.error) {
        return;
    }

    if (response.displayModal) {
        let addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog');

        if (!addToCartWarningDialog) {
            const isOnCartPage = window.location.pathname === '/cart/';
            const fragment = renderFragment(
                dialogTemplate({
                    buttons: isOnCartPage ? [{ text: 'OK', primary: true }] : [{ text: 'Close' }, { text: 'Review Tote', primary: true, link: response.redirectLink }],
                    modalContentHeading: response.messageHeading,
                    modalContentBody: isOnCartPage ? response.messageBodyOnCart : response.messageBodyOffCart,
                    id: 'add-to-cart-warning-dialog'
                })
            );

            document.body.appendChild(fragment);
            addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog');
        }

        $(addToCartWarningDialog).modal('show');
    } else {
        const messageType = response.error ? 'alert-danger' : 'alert-success';
        // show add to cart toast
        remove(queryAll('.add-to-cart-messages'));

        let addToCartMessages = queryFirst('.add-to-cart-messages');
        if (!addToCartMessages) {
            document.body.appendChild(renderFragment('<div class="add-to-cart-messages"></div>'));
            addToCartMessages = queryFirst('.add-to-cart-messages');
        }

        addToCartMessages.appendChild(renderFragment(addToCartAlert(messageType, response.message)));

        setTimeout(() => {
            remove(queryAll('.add-to-basket-alert'));
        }, 5000);
    }
}

/**
 * Get Add to Cart url
 *
 * @param {HTMLElement} container - product tile element
 * @returns {string} flowIPAddresses
 */
function getAddToCartUrl(container) {
    return queryFirst('.add-to-cart-url', container).value;
}

const handleTilesAddToCart = () => {
    $body.on('click', '.js-tile-add-to-cart', async e => {
        e.preventDefault();
        const el = e.currentTarget;
        const csrfResult = await ensureFreshCsrfToken();

        // Skip if this button is inside the OOS alternatives sheet
        if (hasClass(el, 'js-oos-add-to-cart')) return;
        const container = el.closest(SELECTOR_PRODUCT_TILE);

        const pid = getSelectedPid(container);
        const analyticsData = getAddToCartAnalyticsData();
        const { isStyliticsCompleteLookItem } = container.dataset;

        const ajaxData = queryFirst('.js-ajax-data');
        const csrfToken = ajaxData?.dataset?.csrfTokenValue;

        const form = {
            pid,
            csrf_token: csrfToken,
            isStyliticsCompleteLookItem,
            ...analyticsData
        };

        // if the product is from Stylitics Complete Look widget then add styliticsRequestedId to the form data
        let styliticsPlacementValue = null;
        if (isStyliticsCompleteLookItem === 'true') {
            const styliticsCompleteLookContainer = el.closest('.js-complete-look-container');
            if (styliticsCompleteLookContainer) {
                const { styliticsRequestedId, styliticsPlacement } = styliticsCompleteLookContainer.dataset;
                form.styliticsRequestedId = styliticsRequestedId;
                styliticsPlacementValue = styliticsPlacement;
            }
        }

        const addToCartUrl = getAddToCartUrl(container);
        if (pid && addToCartUrl) {
            let resData;
            try {
                const res = await fetch(addToCartUrl, {
                    method: 'POST',
                    body: toFormData(form)
                });
                resData = await res.json();
                if (!res.ok) throw new Error('Add to cart response was not OK');
                handlePostCartAdd(resData);

                if (!resData.error && isCartPage()) {
                    $.spinner().start();
                    window.location.reload();
                } else {
                    $.spinner().stop();
                }

                if (!resData.error && isStyliticsCompleteLookItem === 'true') {
                    resData.isAddedStyliticsCompleteLookItem = true;
                    // send analytics event to track "Add to Cart" from Stylitics Complete Look widget
                    const selectedVariationGroup = queryFirst('.js-tile-swatch.selected', container);
                    if (selectedVariationGroup) {
                        const { productId } = selectedVariationGroup.dataset;
                        container.dispatchEvent(new CustomEvent('stylitics:completeLook:addItemToCart', {
                            detail: {
                                pid: productId,
                                price: queryFirst('.price-section .sales .ssSalesPrice', container)?.value,
                                placement: 'widget',
                                target: styliticsPlacementValue
                            },
                            bubbles: true
                        }));
                    }
                }
                $body.trigger('product:afterAddToCart', resData);
            } catch (err) {
                $.spinner().stop();
                console.error('addToCart error:', err.message);
                if (resData?.csrfError) {
                    $body.trigger('csrf:error');
                }
            }
        }
    });
};

export default handleTilesAddToCart;
